/**
 * ScopedWatchlistPicker - Watchlist picker scoped to the player detail area
 *
 * Renders inside a ScopedModal portaled to PLAYER_DETAIL_PORTAL so the overlay
 * stays within the player detail panel. Used on desktop instead of the
 * full-viewport AddToWatchlistActionsheet.
 */

export { default } from "./ScopedWatchlistPickerContainer";
